import React, { Fragment }  from 'react';
import preventBack from '../hoc/preventBack';

const Error = (props) => {
  const sessionExpired = props.location.state && props.location.state.sessionExpired;
  const message = props.location.state && props.location.state.message ? props.location.state.message : null;
  
  const printMessage = () => {
    if (sessionExpired) {
      return (
        <Fragment>
          <p className="error__text">Lo sentimos, pero tu sesión ha terminado.</p>
          <p className="error__text">Puedes comenzar nuevamente dando clic en el siguiente botón.</p>
        </Fragment>
      );
    } else if (message !== null && message !== '') {
      return <p className="error__text">{message}</p>;
    }

    return <p className="error__text">Lo sentimos algo ha salido mal, estamos trantando de solucionarlo.</p>;
  };

  return (
    <div className="error">
      <h1 className="title">{sessionExpired ? 'Tu sesión expiró' : 'Algo salió mal'}</h1>
      <figure className="error__img">
        <img src={sessionExpired ? require('../static/images/expiro.png') : require('../static/images/error.png')} alt="" /> 
      </figure>

      {printMessage()}

      <a href="https://yelmocines.es/cartelera/" className="btn btn--primary">Ir al inicio</a>
    </div>
  );
};

export default preventBack(Error);
